// ============================================================================
// IMPORTANT: Console Override for Production Builds
// This MUST be the first import to ensure console logs are stripped in production
// ============================================================================
import './utils/consoleOverride';

import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MsalProvider } from '@azure/msal-react';
import { msalInstance } from './msalInstance';
import { devConsole } from './utils/devConsole';

// Always remove legacy mock mode flag to ensure 100% live API mode
try {
  localStorage.removeItem('useMockApi');
} catch (e) {
  // ignore storage errors
}

// initialize() must be called before passing to MsalProvider.
// MsalProvider handles handleRedirectPromise internally -- no need to call it here.
const initializeMsal = async () => {
  try {
    await msalInstance.initialize();
  } catch (error) {
    devConsole.error('MSAL initialization error:', error);
  }
  
  const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
  );

  root.render(
    <React.StrictMode>
      <MsalProvider instance={msalInstance}>
        <App />
      </MsalProvider>
    </React.StrictMode>
  );
};

initializeMsal();

reportWebVitals();
